/**
 * Returns the first non-null value in a list
 */
export function coalesce<T>(...args: T[]): T {
	const len = arguments.length;
	for (let i = 0; i < len; i++) {
		if (arguments[i] !== null && arguments[i] !== undefined) {
			return arguments[i];
		}
	}
	return null;
}
